import searchSession from '@/js/common/Domain/Service/search/searchSession';
import SerpTrackingService, { type ListingPageType } from '@ve/pages/serp/analytics/yandexAnalytics/serpTrackingService';
import type { ExWindow } from '@ve/types';

declare let window: ExWindow;

const serpTrackingService = new SerpTrackingService();

const TRACKED_PAGE_TYPES: Record<string, ListingPageType> = {
    'country.CountryPage': 'country',
    'resort.ResortPage': 'resort',
};

const RESORTS_PATH_SEGMENT = 'resorts';

const FIRST_LOADED_PAGE_NUMBER = 1;

let lastReportedPageNumber: number | null = null;

function getPageType(): ListingPageType | null {
    return TRACKED_PAGE_TYPES[window.appConfig?.pageDataType ?? ''] ?? null;
}

function getPathSegments(): string[] {
    return window.location.pathname.split('/').filter(Boolean);
}

function getCountrySlug(): string {
    return getPathSegments()[0] || '';
}

function getResortSlug(): string {
    const [, resortsSegment, resortSlug] = getPathSegments();

    return resortsSegment === RESORTS_PATH_SEGMENT ? resortSlug || '' : '';
}

function getSearchStateId(): string {
    return String(searchSession.getSearchId() || '');
}

interface ListingAutoloadState {
    pageNumber: number;
    cardsLoaded: number;
}

export function trackListingAutoload({ pageNumber, cardsLoaded }: ListingAutoloadState): void {
    const pageType = getPageType();

    if (!pageType || pageNumber <= FIRST_LOADED_PAGE_NUMBER || pageNumber === lastReportedPageNumber) {
        return;
    }

    lastReportedPageNumber = pageNumber;

    serpTrackingService.listingAutoload({
        pageType,
        country: getCountrySlug(),
        resort: getResortSlug(),
        batch: String(pageNumber - FIRST_LOADED_PAGE_NUMBER),
        cardsLoaded: String(cardsLoaded),
        sid: getSearchStateId(),
    });
}

export function resetListingAutoloadTracking(): void {
    lastReportedPageNumber = null;
}
